import React, { Component } from 'react';
import PropTypes from 'prop-types';
import texts from '../texts/mainMessages';

export default class MessageBox extends Component {

    static propTypes = {
        lang: PropTypes.string.isRequired,
        stateCode: PropTypes.number.isRequired
    };

    createMarkup(code) {
      let text = texts[this.props.lang];

      return {__html: text[code]};
    };

    render() {

        return (
          <div className="panel panel-default">
            <div className="panel-body" dangerouslySetInnerHTML={this.createMarkup(this.props.stateCode)} >
            </div>
          </div>
            );
  }
}
